import classNames from 'classnames';
import bindAll from 'lodash.bindall';
import PropTypes from 'prop-types';
import React from 'react';
import styles from './dialog.css';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { hideBrainConnectionReminderDialog } from '../../reducers/dialog.js';
import {
    uiType,
    getUIStyle
} from '../../reducers/ui-style.js';

class RemindConnectionDialog extends React.Component {
    constructor(props) {
        super(props);
        bindAll(this, [
            'ref'
        ]);
        this.licenseList = [];
    }
    componentDidMount() {
    }
    componentDidUpdate(prevProps) {
    }
    componentWillUnmount() {
    }

    ref(c) {
        this.dialog = c;
    }


    render() {
        return (
            <div className={styles.backdropStyle}>
                <div className={classNames(styles.modalStyle)}
                    ref={this.ref}>
                    <div className={styles.aboutHeader}>
                        <div className={styles.aboutTitle}>
                            <FormattedMessage
                                defaultMessage="Connecting"
                                description="Connecting to Host"
                                id="gui.dialog.connect.title"
                            />
                        </div>
                    </div>

                    <div className={styles.questionView}>
                        <div className={styles.connectBrainDescription}>
                            <FormattedMessage
                                description="Connecting to Brain reminder content"
                                id="gui.dialog.brain.connection.content"
                            />
                            <img className={styles.connectBrain} alt={'content'} />
                            <div className={classNames(
                                styles.questionBtn
                            )} onClick={() => this.props.onClose()}>
                                <FormattedMessage
                                    defaultMessage="Confirm"
                                    description="edit block dialog confirm button"
                                    id="gui.dialog.confirm"
                                />
                            </div>
                        </div>
                    </div>

                </div>
            </div >
        );
    }
}



RemindConnectionDialog.propTypes = {
    onClose: PropTypes.func.isRequired,
    show: PropTypes.bool,
};

RemindConnectionDialog.defaultProps = {
};

const mapStateToProps = state => ({

});

const mapDispatchToProps = dispatch => ({
    onClose: () => dispatch(hideBrainConnectionReminderDialog()),
})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(RemindConnectionDialog);